// utils/user.ts
import { STORAGE_KEYS } from '@/constants';
export const getUserInfo = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEYS.USER_INFO);
    if (!raw) return { role: '0' };
    return JSON.parse(raw);
  } catch {
    return { role: '0' };
  }
};

export function getViewType() {
  const menuType = localStorage.getItem('menuType');
  if (!menuType) return null;
  // Nếu menuType là chuỗi JSON, parse ra, nếu không thì dùng trực tiếp
  let value = menuType;
  try {
    value = JSON.parse(menuType);
  } catch {}
  if (value === 'A1') return '1';
  if (value === 'A2') return '2';
  return null;
}

